// src/components/LenderInfo.js

import React from 'react';
import { Box, Avatar, Typography, Rating } from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';

const LenderInfoContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
}));

const LenderInfo = ({ lender }) => {
    return (
        <LenderInfoContainer>
            <Avatar src={lender.profile_picture} alt={lender.first_name} sx={{ width: 64, height: 64, marginRight: 2 }}>
                {lender.first_name?.[0]}
            </Avatar>
            <Box>
                <Typography variant="h6">
                    {lender.first_name} {lender.last_name}
                </Typography>
                <Rating value={lender.average_rating} readOnly size="small" />
                <Typography variant="body2" color="text.secondary" mt={1}>
                    Borrowers and Lenders are required to validate their identity and provide a valid government-issued ID. This is to ensure the safety and security of all users on the platform.
                </Typography>
            </Box>
        </LenderInfoContainer>
    );
};

LenderInfo.propTypes = {
    lender: PropTypes.shape({
        profile_picture: PropTypes.string,
        first_name: PropTypes.string.isRequired,
        last_name: PropTypes.string.isRequired,
        average_rating: PropTypes.number,
    }).isRequired,
};

export default LenderInfo;
